import React, { ReactNode } from 'react';
import { capitalize } from 'lodash';
import { TitleWithDescription } from '@infoods/lifebase-ui';
import { Tooltip } from '@mui/material';

import { GridTableCell } from '../../../../../../shared/components/table-components';

type CustomerCellProps = {
  nickname: string;
  gender: string;
  age: number;
  tooltip?: ReactNode;
};

const CustomerCell = ({ nickname, gender, age, tooltip = null }: CustomerCellProps) => {
  return (
    <GridTableCell>
      <Tooltip title={tooltip} placement="right" arrow>
        <div>
          <TitleWithDescription
            title={nickname}
            titleFont="body-14-bold"
            description={`${capitalize(gender)}, ${age}`}
          />
        </div>
      </Tooltip>
    </GridTableCell>
  );
};

export { CustomerCell };
